export default {
      id: "i-arrow-right-accordion-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right-accordion",
      toString: function () {
        return this.url;
      }
    }